module.exports = "https://coursera_assets.s3.amazonaws.com/images/1744ee073025c388e7c5936e108cc6ae.svg";